import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { GET_AREA_WITH_AREA_CONTESTS } from "@/queries/GetAreaWithAreaContest";
import { useQuery } from "@apollo/client";
import { Chip } from "@mui/material";
export var AreaContestItems = function (props) {
    var record = props.record;
    var data = useQuery(GET_AREA_WITH_AREA_CONTESTS, {
        variables: {
            electionEventId: record.election_event_id,
            areaId: record.id,
        },
    }).data;
    var aliasRenderer = useAliasRenderer();
    return (_jsx(_Fragment, { children: data && data.sequent_backend_area_contest
            ? data.sequent_backend_area_contest.map(function (item, index) { return (_jsx(Chip, { label: aliasRenderer(item === null || item === void 0 ? void 0 : item.contest) }, index)); })
            : null }));
};
